import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X, ChevronDown } from 'lucide-react';
import './Header.css';

const navItems = [
  { path: '/', label: 'Home' },
  {
    path: '/services',
    label: 'Solutions',
    sub: ['Cloud & DevOps', 'Cybersecurity', 'AI & Automation', 'Managed Services'],
  },
  { path: '/industries', label: 'Industries' },
  // { path: '/about', label: 'Leadership' },
  { path: '/blog', label: 'Blog' },
  { path: '/contact', label: 'Contact' },
];

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close mobile menu on route change
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  return (
    <>
      <motion.header
        className={`header${isScrolled ? ' scrolled' : ''}`}
        initial={{ y: -20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <div className="header-inner container">
          {/* Brand */}
          <Link to="/" className="nav-brand">
            <img src="/logofull.png" alt="Wayug Infotech Solutions - Enterprise IT Services & Custom Software" className="logo-img" />
            <span className="brand-tag">Enterprise IT Solutions</span>
          </Link>

          {/* Desktop Nav */}
          <nav className="nav-center">
            <ul>
              {navItems.map((item) => (
                <li key={item.path} className="nav-item">
                  <Link
                    to={item.path}
                    className={`nav-link${location.pathname === item.path ? ' active' : ''}`}
                  >
                    {item.label}
                    {item.sub && <ChevronDown size={14} style={{ marginLeft: '4px', verticalAlign: 'middle' }} />}
                  </Link>
                  {item.sub && (
                    <div className="dropdown">
                      {item.sub.map((subLabel) => (
                        <Link
                          key={subLabel}
                          to={item.path}
                          className="dropdown-item"
                        >
                          {subLabel}
                        </Link>
                      ))}
                    </div>
                  )}
                </li>
              ))}
            </ul>
          </nav>

          {/* Right Actions */}
          <div className="nav-right">
            <a href="https://wa.me/918287999236?text=Hi!%20I%20would%20like%20to%20get%20started%20with%20Wayug%20Infotech." target="_blank" rel="noopener noreferrer" className="btn btn-accent nav-cta">
              Get Started
            </a>
            <button
              className="mobile-menu-btn"
              onClick={() => setIsMobileMenuOpen((prev) => !prev)}
              aria-label="Toggle menu"
            >
              {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </motion.header>

      {/* Mobile Menu Overlay */}
      <AnimatePresence>
        {isMobileMenuOpen && (
          <motion.div
            className="mobile-menu"
            initial={{ x: '-100%' }}
            animate={{ x: 0 }}
            exit={{ x: '-100%' }}
            transition={{ type: 'tween', duration: 0.3 }}
          >
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              {navItems.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className={`mobile-nav-link${location.pathname === item.path ? ' active' : ''}`}
                  >
                    {item.label}
                  </Link>
                  {item.sub && (
                    <ul style={{ listStyle: 'none', padding: '0 0 0 1rem', margin: 0 }}>
                      {item.sub.map((subLabel) => (
                        <li key={subLabel}>
                          <Link
                            to={item.path}
                            className="mobile-nav-link"
                            style={{ fontSize: '0.95rem', paddingTop: '0.65rem', paddingBottom: '0.65rem' }}
                          >
                            {subLabel}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
            </ul>
            <div className="mobile-menu-footer">
              <a href="https://wa.me/918287999236?text=Hi!%20I%20would%20like%20to%20get%20started%20with%20Wayug%20Infotech." target="_blank" rel="noopener noreferrer" className="btn btn-accent mobile-cta">
                Get Started
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}